import { render, staticRenderFns } from "./FranchiseStore.vue?vue&type=template&id=807d238c&scoped=true&"
import script from "./FranchiseStore.vue?vue&type=script&lang=js&"
export * from "./FranchiseStore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "807d238c",
  null
  
)

export default component.exports